import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UploaderOptions, UploadFile, UploadInput, UploadOutput, UploadStatus} from 'ngx-uploader';
import {ApiService} from '../../../@core/service/api.service';
import {FileModel, EFileType} from '../../../@models';

@Component({
  selector: 'ngx-form-upload',
  templateUrl: './form-upload.component.html',
  styleUrls: ['./form-upload.component.scss'],
})

export class FormUploadComponent implements OnInit {
  @Input() url: string;
  @Input() title: string;
  @Input() files: FileModel[];
  @Input() file: FileModel;
  @Input() hideUpload: boolean = false;
  @Input() hideComment: boolean = true;
  @Input() hideCheckbox: boolean = true;
  @Input() disabled: boolean = false;
  @Input() fullwidth: boolean = false;
  @Input() accept: string = null;
  @Input() descriptionOptions: string[] = null;
  @Input() additionalFieldLabel: string = null;
  @Input() additionalDateLabel: string = null;
  @Input() preview = false;
  
  @Output() filesChange: EventEmitter<FileModel[]> = new EventEmitter<FileModel[]>();
  @Output() fileChange: EventEmitter<FileModel> = new EventEmitter<FileModel>();

  @Output() completed: EventEmitter<FileModel[]> = new EventEmitter<FileModel[]>();

  @Input() moveToText: string = null;
  @Output() moveTo: EventEmitter<number> = new EventEmitter<number>();

  // JSON = JSON;

  formData: FormData;
  uploadFiles: UploadFile[];
  uploadInput: EventEmitter<UploadInput>;
  // humanizeBytes: Function;
  dragOver: boolean;
  options: UploaderOptions;

  constructor(private api: ApiService) {
    this.options = { concurrency: 1, maxUploads: 30 };
    this.uploadFiles = [];
    this.uploadInput = new EventEmitter<UploadInput>();
    // this.humanizeBytes = humanizeBytes;
  }

  ngOnInit(): void {
    if (this.file && !this.files) this.files=[this.file]; 
  }

  onUploadOutput(output: UploadOutput): void {
    // console.log('onUploadOutpu', this.files, this.uploadFiles);
    if (output.type === 'allAddedToQueue') {
      const event: UploadInput = {
        type: 'uploadAll',
        url: this.url,
        method: 'POST',
        data: { foo: 'bar' },
        headers: {authorization: this.api.token},
      };

      this.uploadInput.emit(event);
    } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') {
      this.uploadFiles.push(output.file);
    } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
      const index = this.uploadFiles.findIndex(
        file => typeof output.file !== 'undefined' && file.id === output.file.id);
      this.uploadFiles[index] = output.file;
    } else if (output.type === 'cancelled' || output.type === 'removed') {
      this.uploadFiles = this.uploadFiles.filter((file: UploadFile) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
      this.dragOver = false;
    } else if (output.type === 'drop') {
      this.dragOver = false;
    } else if (output.type === 'rejected' && typeof output.file !== 'undefined') {
      // console.log(output.file.name + ' rejected');
    }

    this.uploadFiles.forEach(f => {
      if (f.progress.status === UploadStatus.Done) {
        if (this.files == null) this.files = [];

        const r = f.response[0];

        let ft;
        switch (r.mimetype) {
          case 'application/pdf':
            ft = EFileType.Pdf;
            break;
          case 'image/jpg':
          case 'image/jpeg':
          case 'image/png':
            ft = EFileType.Image;
            break;
        }

        this.files.push({
          name: f.name,
          type: EFileType.Unknown,
          url: '/files/' + r.filename,
          checked: true,
        });
        this.filesChange.emit(this.files);
        this.fileChange.emit(this.files[0])
      }
    });

    this.uploadFiles = this.uploadFiles.filter(file => file.progress.status !== UploadStatus.Done);
    this.completed.emit(this.files);

  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  removeFile(id: string): void {
    this.uploadInput.emit({ type: 'remove', id: id });
  }

  removeAllFiles(): void {
    this.uploadInput.emit({ type: 'removeAll' });
  }

  remove(file: FileModel): void {
    this.files = this.files.filter(x => x.url !== file.url);

    this.filesChange.emit(this.files);
    this.fileChange.emit(this.files[0]);
    this.completed.emit();
  }

  async downloadFile(file: FileModel) {
    await this.api.downloadFile(file)
  }

  drag($event: DragEvent, file: FileModel) {
    // console.log($event);
    // console.log(file)
    $event.dataTransfer.setData('text', `[${file.name}]`);
  }

  onMoveFile(idx: number, up: boolean) {
    const cut = this.files.splice(idx, 1);
    this.files.splice(idx + (up ? -1 : 1), 0, cut[0]);
    this.completed.emit();
  }

  fileChecked(file: FileModel) {
    file.checked = !file.checked;
    this.completed.emit();
  }

  canShowPreview(file: FileModel) {
    return this.preview && /\.(jpe?g|gif|png)/i.test(file.name) //file.type === EFileType.Image && this.preview;
  }

}
